const sortActionBranch = (actions = []) => {
    const sortedActions = [...actions].sort((left, right) => {
        const sequenceDiff =
            Number(left.sequence_id) - Number(right.sequence_id)
        if (sequenceDiff !== 0) {
            return sequenceDiff
        }

        return Number(left.id) - Number(right.id)
    })

    return sortedActions.map((action) => ({
        ...action,
        children: sortActionBranch(action.children || []),
    }))
}

export const normalizeActionRecords = (records = []) => {
    const normalizedNodes = records.map((action, index) => ({
        id: action.id,
        name: action.name || `Action ${index + 1}`,
        parent:
            action.parent !== null && action.parent !== undefined
                ? Number(action.parent)
                : null,
        sequence_id:
            action.sequence_id !== null && action.sequence_id !== undefined
                ? Number(action.sequence_id)
                : index + 1,
        weight:
            action.weight !== null && action.weight !== undefined
                ? Number(action.weight)
                : 0,
        children: [],
    }))

    const nodeById = new Map(normalizedNodes.map((node) => [node.id, node]))
    const rootNodes = []

    for (const node of normalizedNodes) {
        if (node.parent === null || !nodeById.has(node.parent)) {
            rootNodes.push(node)
            continue
        }

        const parentNode = nodeById.get(node.parent)
        parentNode.children.push(node)
    }

    return sortActionBranch(rootNodes)
}

export const flattenActionsForPersistence = (actions = [], parentId = null) =>
    actions.reduce((acc, action, index) => {
        const currentItem = {
            id: action.id,
            parent: parentId,
            sequence_id: index + 1,
            name: action.name,
            weight: action.weight,
        }

        return [
            ...acc,
            currentItem,
            ...flattenActionsForPersistence(action.children || [], action.id),
        ]
    }, [])

export const getActionsSignature = (actions = []) =>
    JSON.stringify(
        flattenActionsForPersistence(actions).map(
            ({ id, parent, sequence_id, name }) => ({
                id,
                parent,
                sequence_id,
                name,
            })
        )
    )
